import React from 'react';
import { AppBar, Toolbar, Typography, Box, Button } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { ArrowBack, Logout as LogoutIcon } from '@mui/icons-material'; // Adicionado LogoutIcon
import { useNavigate, useLocation } from 'react-router-dom';

// Define a interface para as props do Header (pode ser mantida vazia ou removida se não for usada)
interface HeaderProps {
  // Você pode adicionar props aqui se o Header precisar receber dados de componentes pais
}

const Header: React.FC<HeaderProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Tenta pegar o usuário do localStorage
  const userString = localStorage.getItem('user');
  let userNameToShow = ''; // Nome do usuário para exibir
  let isAuthenticated = false; // Flag para saber se o usuário está autenticado

  if (userString) {
    try {
      const user = JSON.parse(userString);
      userNameToShow = user.name || user.username; // Usa o nome completo ou o username
      isAuthenticated = true; // Se temos dados do usuário, ele está autenticado
    } catch (e) {
      console.error("Erro ao ler dados do usuário do localStorage:", e);
      // Em caso de erro ao ler, consideramos como não autenticado para segurança
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
    }
  }
  
  // Verifica se o token existe para uma dupla checagem (embora o 'user' seja suficiente aqui)
  const token = localStorage.getItem('authToken');
  if (!token && isAuthenticated) {
    // Se não há token mas havia userString, limpa por segurança
    isAuthenticated = false;
    localStorage.removeItem('user');
  }


  // Determina se o botão "Voltar" deve ser exibido
  const showBackButton = location.pathname !== '/' && location.pathname !== '/login';

  const handleGoBack = () => {
    navigate(-1); 
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    navigate('/login');
    window.location.reload(); // Força recarregar a página para limpar qualquer estado
  };

  return (
    <AppBar
      position="static"
      sx={{
        background: 'linear-gradient(90deg, #1a237e 0%, #283593 100%)',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
      }}
    >
      <Toolbar>
        {isAuthenticated && showBackButton && ( // Mostra "Voltar" apenas se autenticado e não na raiz/login
          <Button
            color="inherit"
            startIcon={<ArrowBack />}
            onClick={handleGoBack}
            sx={{ mr: 2 }}
          >
            Voltar
          </Button>
        )}
        <DashboardIcon sx={{ mr: isAuthenticated ? 1 : 2, fontSize: 28 }} /> {/* Ajusta margem se o botão voltar não estiver lá */}
        <Typography variant="h5" component="div" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
          Dashboard - Grupo Solução
        </Typography>
        
        {isAuthenticated ? ( // Se autenticado, mostra saudação e botão Sair
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="subtitle1" sx={{ mr: 2, display: { xs: 'none', sm: 'block' } }}> {/* Oculta em telas pequenas */}
              Olá, {userNameToShow}!
            </Typography>
            <Button
              color="inherit"
              onClick={handleLogout}
              startIcon={<LogoutIcon />}
              variant="outlined" // Adiciona um estilo para destacar
              sx={{ borderColor: 'rgba(255,255,255,0.7)', '&:hover': { borderColor: 'white'}}}
            >
              Sair
            </Button>
          </Box>
        ) : ( // Se não autenticado, pode mostrar algo diferente ou nada
          location.pathname !== '/login' && ( // Não mostra "Análise de Vendas" na tela de login
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="subtitle1" sx={{ mr: 3, opacity: 0.9 }}>
                    Análise de Vendas
                </Typography>
            </Box>
          )
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
